import styled from 'styled-components';

export const SearchResultsContainer = styled.div`

    @media screen and (min-width: 801px) {
        background-color: #222222;
    }

    padding-top: 2rem;
    padding-bottom: 2rem;
    margin-right: 3rem;
    margin-left: 3rem;
    margin-top: 3rem;
    margin-bottom: 3rem;
    border-radius: 4px; 
    display: flex;
    flex-wrap: wrap;
 
    justify-content: center;
`

